<template>
    <!--基本信息-->
    <div>
        <div class="common-form">标题</div>
        <div class="pb16">
            {{ detail.title }}
        </div>
        <div class="common-form">发送对象{{ detail.sendobjects === "0" ? '：全部' : '：指定对象' }}</div>
        <el-table :data="tableData" border style="width: 500px;">
            <el-table-column prop="id" label="用户ID">
            </el-table-column>
            <el-table-column prop="nikeName" label="用户名">
            </el-table-column>
        </el-table>
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination">
            </el-pagination>
        </div>
        <div class="common-form">内容</div>
        <div class="pb16">
            <div v-html="detail.content" class="content"></div>
        </div>
        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
        </div>
    </div>
</template>

<script>
import messageApi from '@/api/setting/message.js'
export default {
    data() {
        return {
            detail: '', // 获取详情信息
            tableData: null,
            pageSize: 10,
            pageIndex: 1,
            total: null,
        }
    },
    created() {
        this.getParams()
    },
    methods: {
        // 每页显示多少条数据
        handleSizeChange(val) {
            // console.log(val);
            this.pageSize = val;
            // console.log('1', this.pageIndex, this.pageSize)
            this.getParams(this.pageIndex, this.pageSize, this.$route.query.id);
        },
        handleCurrentChange(val) {
            // console.log(val);
            this.pageIndex = val;
            // console.log('2', this.pageIndex, this.pageSize)
            this.getParams(this.pageIndex, this.pageSize, this.$route.query.id);
        },
        /*获取参数*/
        getParams(pageIndex, pageSize) {
            // console.log(pageIndex, pageSize)
            // 取到路由带过来的参数
            const params = {
                pageIndex: pageIndex,
                pageSize: pageSize,
                id: this.$route.query.id
            };
            // console.log(params)
            messageApi.getMessageDetail(
                {
                    ...params
                },
            )
                .then(res => {
                    this.detail = res.data;
                    this.tableData = this.detail.shopMemberSystemMessageVos.records;
                    this.total = this.detail.shopMemberSystemMessageVos.total
                    // console.log(this.tableData)
                })
                .catch(error => {
                    // console.log(error);
                });
        },
        // 返回上一页
        cancelFunc() {
            this.$router.back(-1);
        },
    }
}
</script>

<style scoped>
.paginationBox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}

.content {
    width: 50%;
}

.content img {
    /* 将图片宽度设置为其容器的最大宽度，保持宽高比例不变 */
    height: auto;
    /* 自适应高度，保持宽高比例不变 */
}
</style>


// WEBPACK FOOTER //
// src/views/setting/message/detail.vue